<template>
    <div class="detail-info" v-if="displayTab">
        <div class="detail-tabs">
            <div class="detail-tabs__wrap clearfix">
                <div
                    v-if="res.display_detail != 1 && res.course_type != 23"
                    v-clickReport="34272802"
                    class="detail-tabs__btn"
                    :class="{active: activeBy == 'timetable'}"
                    @click="onSetActiveByHandler('timetable')"
                >
                    课程大纲
                </div>
                <div
                    v-if="stopSaleStatus !== 1 && displayIntroImg"
                    v-clickReport="34272783"
                    class="detail-tabs__btn"
                    :class="{active: activeBy == 'detail'}"
                    @click="onSetActiveByHandler('detail')"
                >
                    课程详情
                </div>
            </div>
            <div class="detail-tabs__content">
                <div v-show="activeBy == 'detail'" class="detail-tabs__pane">
                    <!-- <div v-if="res.try_listen" class="detail-tabs__audition">
                        <h1 class="title">试听课程</h1>
                        <div class="cover">
                            <img class="bg" src="~assets/img/tryAudio.png" alt="试听课程">
                            <img
                                v-clickReport="34272741"
                                class="playBtn"
                                src="~assets/img/audioPlay.png"
                                alt="播放"
                                @click="onshowVideoHandler"
                            >
                            <p class="try">试听一下</p>
                        </div>
                    </div> -->
                    <div
                        v-if="res.introduction_images && res.introduction_images.length > 0 && stopSaleStatus !== 1"
                        class="detail-tabs__listimg"
                    >
                        <div
                            v-for="(item, index) in res.introduction_images"
                            :key="index"
                            class="detail-tabs__img"
                        >
                            <img v-lazy="item.url" alt="">
                        </div>
                    </div>
                </div>
                <div v-show="activeBy == 'timetable'" class="detail-tabs__pane">
                    <!-- <div
                        v-if="res.content_type == 1"
                        class="detail-tabs__study"
                        @click="onGotoStudyHandler(res)"
                    >
                        点击前往学习中心上课
                    </div> -->
                    <template v-if="res.chapter_infos && res.chapter_infos.length > 0">
                        <multiOutline
                            v-for="(item,index) in res.chapter_infos"
                            :key="index"
                            :section-list="item"
                        />
                    </template>
                    <template v-else>
                        <div
                            v-for="(item, index) in res.lecture_list"
                            :key="index"
                            class="detail-tabs__timetable ellipsis"
                        >
                            <div class="detail-tabs__time" v-if="item.clazz_hours_desc || item.introduction">
                                <span v-if="item.introduction">{{item.introduction}}</span>
                                <span v-if="item.clazz_hours_desc" :class="{time__dot: item.introduction}">{{item.clazz_hours_desc}}</span>
                            </div>
                            <span class="detail-tabs__title">{{item.lecture_title}}</span>
                        </div>
                    </template>
                    <div v-if="res.clazz_hours_intro" class="detail-tabs__btm-info">{{res.clazz_hours_intro}}</div>
                </div>
            </div>
        </div>
        <course-listen
            v-if="res.try_listen"
            ref="courseListen"
            :title="res.title"
            :url="res.try_listen"
            :expire-time="res.try_listen_expire_time"
        />
    </div>
</template>
<script>
import CourseListen from './CourseListen';
// 子章节组件
import MultiOutline from './MultiOutline.vue';
import {mapState} from 'vuex';
import config from '~/environment';

export default {
    name: 'DetailInfo',
    components: {
        CourseListen,
        MultiOutline
    },
    props: {
        res: {
            type: Object,
            default() {
                return {};
            }
        },
        stopSaleStatus: {
            type: Number,
            default: 0
        }
    },
    computed: {
        ...mapState({
            p_client: state => state.p_client
        }),
        displayTab() {
            return (this.res.display_detail != 1 && this.res.course_type != 23) || (this.stopSaleStatus !== 1 && this.displayIntroImg)
        },
        displayIntroImg() {
            const {introduction_images = []} = this.res || {};
            const length = introduction_images.length;
            return length > 1 || (length === 1 && introduction_images[0]?.url);
        }
    },
    watch: {
        stopSaleStatus: {
            handler(newVal, oldVal) {
                if (newVal === 1) {
                    this.activeBy = 'timetable';
                }
            },
            immediate: true
        }
    },
    data() {
        return {
            activeBy: this.res.course_type === 23 ? 'detail' : 'timetable'
        };
    },
    created() {
        this.onCheckCourseType();
    },
    methods: {
        // 检查课程类型
        onCheckCourseType() {
            if (this.res.course_type == 1) {
                if (this.res.content_type == 1) {
                    this.activeBy = 'timetable';
                }
            }
            else if (this.res.course_type > 1) {
                if (this.res.content_type == 1) {
                    this.activeBy = 'timetable';
                }
                else if (this.res.content_type == 1) {
                    this.activeBy = 'detail';
                }
            }
        },
        onSetActiveByHandler(payload) {
            if (this.activeBy == payload) {
                return;
            }
            this.activeBy = payload;
        },
        onGotoStudyHandler(payload) {
            if (this.p_client === 12) {
                const url = payload.course_type === 23 ? `https:${config.env.pcUrl}/account/study` : `https:${config.env.pcUrl}/account/study?clazzNumber=${payload.course_id}`
                window.open(url);
            }
            else {
                if (payload.course_type === 23) {
                    this.$router.push({path: '/account/study'});
                }
                else {
                    this.$router.push({path: `/account/study?clazzNumber=${payload.course_id}`});
                }
            }
        },
        onshowVideoHandler() {
            this.$refs.courseListen.triggerPlayVideo();
        },
    }
};
</script>
<style lang="less" scoped>
.detail-info {
    position: relative;
    background-color: #fff;
    margin-top: 20px;
    border-radius: 4px;
    border: solid 1px #ebebeb;
}

.detail-tabs {
    position: relative;

    &__audition {
        height: 636px;
        background: #fff;
        text-align: center;
        padding: 53px 51px 32px;

        .title {
            font-size: 50px;
            font-weight: 700;
            color: #2a2a2a;
            line-height: 70px;
        }

        .cover {
            position: relative;
            width: 730px;
            height: 412px;
            text-align: center;

            .bg {
                width: 730px;
                height: 412px;
            }

            .playBtn {
                position: absolute;
                top: 138px;
                left: 323px;
            }

            .try {
                position: absolute;
                top: 237px;
                left: 0;
                right: 0;
                font-size: 24px;
                color: #fff;
                line-height: 24px;
                margin: 0;
            }
        }
    }

    &__study {
        position: relative;
        height: 44px;
        line-height: 44px;
        text-align: center;
        font-size: 16px;
        color: #f63232;
        background-color: #feeded;
        cursor: pointer;
    }

    &__timetable {
        position: relative;
        margin: 0 30px;
        font-size: 16px;
        line-height: 18px;
        padding: 28px 0;
        color: #32404b;

        &:not(:last-child) {
            border-bottom: 1px solid #f5f5f5;
        }
    }

    &__time {
        display: inline;
        padding-right: 40px;

        .time__dot::before {
            content: "·";
            margin: 0 6px;
        }
    }

    &__img {
        background: #ebebeb url(~assets/img/course-cover.png) no-repeat center center;

        img {
            display: block;
            width: 100%;
            height: auto;
        }
    }

    &__wrap {
        position: relative;
        height: 60px;
        background-color: #fbfbfb;
    }

    &__content {
        position: relative;
        min-height: 400px;
    }

    &__btn {
        float: left;
        position: relative;
        padding: 0 30px;
        height: 60px;
        line-height: 60px;
        font-size: 20px;
        color: #32404b;
        cursor: pointer;

        &.active {
            background-color: #fff;
            color: #f63232;

            &::before {
                content: "";
                position: absolute;
                left: 0;
                right: 0;
                top: -1px;
                height: 2px;
                background-color: #f63232;
            }
        }
    }

    &__btm-info {
        color: #818a92;
        font-size: 14px;
        line-height: 20px;
        margin: 15px 30px 40px;
    }
}
</style>
